// extracted by mini-css-extract-plugin
module.exports = {"playboxContainer":"PlayBox_playboxContainer__1whzQ","playbox":"PlayBox_playbox__2K1Z5","resetBtn":"PlayBox_resetBtn__1mCF0","heightForce":"PlayBox_heightForce__1IUGD"};